import { List } from 'antd';
import type { JSX } from 'react';
import { useUserOrganizations } from '../../hooks/useOrganizations';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { OrganizationRegistrationProcessComponent } from '../OrganizationRegistrationProcessComponent';

const OrganizationListComponent = (): JSX.Element => {
  const userOrganizations = useUserOrganizations(useCurrentUser().id);

  return (
    <List
      bordered
      size="large"
      dataSource={userOrganizations.data ?? []}
      renderItem={(item) => {
        return (
          <OrganizationRegistrationProcessComponent userOrganization={item} />
        );
      }}
    />
  );
};
export default OrganizationListComponent;
